/*
 * サブシステム名：設定その他
 * 機能名：データ出力
 */

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdDropDown = () => import('@/components/DdDropDown')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'DataExportList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDropDown,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdSubHeader
  },
  data: () => ({
    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1,

    isConditionHide: false,
    conditions: {
      fileFormatCd: '',
      kaishaCd: '',
      dataFile: {
        value: '',
        input: ''
      }
    },
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kubunList: 'DDMasters/msysKubun',
      fileFormatNm: 'DDMasters/mstFileFormatKihon',
      currentKaishaCode: 'users/currentKaishaCode'
    }),
    filteredFileFormatNm () {
      return this.fileFormatNm.filter(function (elem) {
        return elem.fileFormatCd < '900' && (elem.fileFormatKbn === '1' || elem.fileFormatKbn === '3')
      }).map(function (elem) {
        elem.value = elem.fileFormatCd
        elem.text = elem.fileFormatNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.fileFormatCd > elem2.fileFormatCd) { return 1 }
        if (elem1.fileFormatCd === elem2.fileFormatCd) { return 0 }
        return -1
      })
    },
    filteredProcessKbn () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN017'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isValidCSVTemplate () {
      if (this.conditions.fileFormatCd) {
        return true
      }
      return false
    },
    selectedFileFormatName () {
      const self = this
      return this.fileFormatNm.filter(function (elem) {
        return elem.fileFormatCd === self.conditions.fileFormatCd
      }).map(function (elem) {
        elem.fileFormatNm = elem.fileFormatNm.trim()
        return elem
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.exportYmdDisp = elem.exportYmd ? dayjs(dayjs(elem.exportYmd).format('YYYY/MM/DD') + ' ' + elem.exportHms).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.exportUserNmDisp = elem.exportUserId ? elem.exportUserId + ':' + elem.exportUserNm : ''
        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstfileformatkihon', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'id' },
              { text: '出力指示日時', value: 'exportYmdDisp' },
              { text: '出力指示者', value: 'exportUserNmDisp' },
              { text: 'データの種類', value: 'fileFormatNm' }
              // { text: 'フォーマットの種類', value: 'fileFormatKbnNm' }
            ]
            resolve()
          }).then(() => {
            // 出力履歴一覧取得
            return new Promise(resolve => {
              this.HttpClient
                // .post('/api/v1/vwCD2utld0010/search', { max: '899' })
                .get('/api/v1/TrExportHistory/GetAll')
                .then((data) => {
                  if (data.isValid) {
                    this.rows = data.payload
                  } else {
                    this.rows = []
                  }
                  resolve(data)
                })
            })
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              fileFormatCd: '',
              kaishaCd: self.currentKaishaCode,
              // kaishaCd: '0010',
              processKbn: '1',
              filePath: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              fileFormatCd: '',
              kaishaCd: this.currentKaishaCode,
              processKbn: '1',
              filePath: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        const self = this
        const isUtf8 = self.isFileUtf8(this.conditions.fileFormatCd)
        // self.HttpClient.post('/api/v1/TrExportHistory/export', self.conditions).then((data) => {
        if (isUtf8) {
          self.HttpClient.post('/api/v1/TrExportHistory/exportMapping', self.conditions).then((data) => {
            const bom = new Uint8Array([0xef, 0xbb, 0xbf])
            const blob = new Blob([bom, data], { type: 'text/csv' })
            const elem = document.getElementById('export')
            elem.href = window.URL.createObjectURL(blob)
            elem.download = self.selectedFileFormatName[0].text + '_' + self.getFormatDate(new Date()) + '.csv'
            elem.click()
          }).then((data2) => {
            self.initialize()
            this.Effects.loadComplete()
          })
        } else {
          this.HttpClient
            .requestFileByPost('/api/v1/TrExportHistory/exportMapping', this.conditions)
            .then((data) => {
              // エラー初期化
              this.clearSummaryMessage()
              if (data.invalidList !== undefined) {
                // エラーあり形式が返却された場合
                // エラー設定
                this._setMessages(data)
              } else {
                // CSVデータ形式（エラーなし形式）が返却された場合
                // CSV出力
                // const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
                const blob = new Blob([data], { type: 'text/csv' })
                const elem = document.getElementById('export')
                elem.href = window.URL.createObjectURL(blob)
                elem.download = self.selectedFileFormatName[0].text + '_' + self.getFormatDate(new Date()) + '.csv'
                elem.click()
              }
            }).then((data2) => {
              self.initialize()
              this.Effects.loadComplete()
            })
        }
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id, edit: 0 })
    },
    getFormatDate: function (date) {
      const formatDate = new Date(date)
      const Y = formatDate.getFullYear()
      const M = ('00' + (formatDate.getMonth() + 1)).slice(-2)
      const D = ('00' + formatDate.getDate()).slice(-2)
      const h = ('00' + formatDate.getHours()).slice(-2)
      const m = ('00' + formatDate.getMinutes()).slice(-2)
      const s = ('00' + formatDate.getSeconds()).slice(-2)
      return Y + M + D + '_' + h + m + s
    },
    searchValidate: function () {
      return true
    },
    storeFileInfo: function (file) {
      console.log('file selected', file)

      if (file === undefined || file === null) {
        this.conditions.fileData = ''
        this.conditions.fileName = ''
        return
      }
      this.conditions.fileName = file.name

      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.fileData = fr.result
      })
      console.log('file selected e')
    },
    CSVtemplateClick: function (e) {
      console.log('csvtemplate clicked')
      // TODO call file export only headers
    },
    isFileUtf8 (fileFormatCd) {
      const r = this.filteredFileFormatNm.find((p) => {
        return p.fileFormatCd === fileFormatCd
      })
      if (r && r.characterCodeKbn) {
        if (r.characterCodeKbn.toLowerCase() === 'ms932' || r.characterCodeKbn.toLowerCase() === 'shift_jis' || r.characterCodeKbn.toLowerCase() === 'shift-jis') {
          return false
        }
      }
      return true
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
